import { LocalizedText, useDialogAction } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { TableBulkActionButton } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';
import { WithEnterpriseIds } from '../../../enterpriseRateManagement/types';
import { PropertyGroupContainer } from '../PropertyGroupContainer/PropertyGroupContainer';
import { ADD_TO_PROPERTY_GROUP_STARTING_POINT } from '../../utilities/userFlowTestIds';

export const AddPropertiesGroup = ({ enterpriseIds }: WithEnterpriseIds) => {
    const { states, handlers } = useDialogAction(async () => Promise.resolve());

    const areNoRowsSelected = enterpriseIds.length === 0;

    const handleSuccess = async () => {
        await handlers.handleConfirm();
    };

    return (
        <>
            <TableBulkActionButton
                onClick={() => {
                    handlers.handleOpen();
                }}
                icon={IconName.Marketplace}
                disabled={areNoRowsSelected}
                data-test-id={ADD_TO_PROPERTY_GROUP_STARTING_POINT}
            >
                <LocalizedText textKey={TextKey.PropertyAddGroup} />
            </TableBulkActionButton>

            {states.isDialogOpened && (
                <PropertyGroupContainer
                    onConfirm={handlers.handleConfirm}
                    onCancel={handlers.handleCancel}
                    onSuccess={handleSuccess}
                    enterpriseIds={enterpriseIds}
                    isOpened={states.isDialogOpened}
                />
            )}
        </>
    );
};
